import {IActionBase} from "./IActionBase";

import React, {Component} from "react";

import {store} from "../../redux/storeConfig/store";
import {callPostService} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";
import {utils_ui} from "../utils/utils_ui";
import {ActionsManager} from "./actionsManager";
import {cloneDeep} from "lodash";
import {
    executeApplyooComponentsFunction,
    executeApplyooComponentsFunctionWithReturnValue, sendApplyooComponentsNotification
} from "../infrastructure/useApplyooComponent";
import {eSystemEvents, fireApplyooEvent} from "../infrastructure/useApplyooTriggers";
import {utils_log} from "../utils/utils_log";
import {dataUtils} from "../js/dataUtils";

export class save extends Component implements IActionBase {

    actionCode = "save";
    actionName = "save";
    static newKeyNumber = -1;
    static dicActiveSave:any = {};

    valueToAddFirstDecimalTypeFieldRow = 0.0000001

    Execute = (prmActionParameters?:any, prmActionsManager?:ActionsManager, prmElementObj?:any, prmData?:any)=> {
        let queryName:string = "";
        let isValid = true;
        let currPageStruct = store.getState().store_PageStructure.pageStructure;
        let currProjectID = store.getState().store_ProjectData.projectID
        let currPageCode = store.getState().store_PageStructure.pageCode
        let lstValidationErrors:any = [];
        let currDataRequestObj:any =null;
        let lstQueryTablesInfo = null;

        let isSkipValidation = false

        if (!!prmActionParameters?.QueryName) {
            queryName = prmActionParameters.QueryName;

            if (queryName.indexOf(".") > -1) {
                queryName = queryName.substring(0,queryName.indexOf("."))
            }
        }

        if (!!prmActionParameters?.IsSkipValidation) {
            isSkipValidation = prmActionParameters.IsSkipValidation;
        }

        if (!!prmActionParameters?.pageCode) {
            currPageCode = prmActionParameters.pageCode;
            let currPageKey = `${currProjectID}_${currPageCode}`
            let storePageStruct = store.getState().store_PageStructure

            if (!!storePageStruct.dicPageTemplates
                && !!storePageStruct.dicPageTemplates[currPageKey]) {
                currPageStruct = storePageStruct.dicPageTemplates[currPageKey]
            }
        }

        if (!!currPageStruct && !!currPageStruct.LstDataRequests) {
            let arrSaveQueries = currPageStruct.LstDataRequests.filter((prmItem:any) => {
                return !queryName || prmItem.ResponseName == queryName;
            })
            executeApplyooComponentsFunction("saveDataToStore")

            // store.dispatch({type: 'SET_PAGE_STATE',
            //     lstQueryNames:arrSaveQueries,
            //     pageState: 'SAVE_COMPONENTS_DATA_TO_STORE', //comment: convert to enum
            // });

            let pageDataObj = cloneDeep(store.getState().store_PageData);

            isValid = true;
            for (let ind01 = 0; ind01 < arrSaveQueries.length; ind01++) {
                currDataRequestObj = arrSaveQueries[ind01];

                if (!currDataRequestObj
                    || !currDataRequestObj.ResponseName
                    || !pageDataObj.getDataResponseObj?.DicQueryEntityHierarchy
                    || !pageDataObj.getDataResponseObj?.DicQueryEntityHierarchy[currDataRequestObj.ResponseName]) {
                    continue
                }

                lstQueryTablesInfo = pageDataObj.getDataResponseObj.DicQueryEntityHierarchy[currDataRequestObj.ResponseName];

                if (!!lstQueryTablesInfo && !isSkipValidation){
                    fireApplyooEvent({eventType: eSystemEvents.OnBeforeSave_CheckDataValidation})
                    //prmActionsManager?.triggersManager.raiseEvent(prmActionsManager,eSystemEvents.OnBeforeSave_CheckDataValidation,currDataRequestObj)
                    lstValidationErrors = utils_ui.validate(currDataRequestObj.ResponseName);

                    if (lstValidationErrors.length > 0){
                        isValid = false;
                        fireApplyooEvent({eventType: eSystemEvents.OnBeforeSave_CheckDataValidation, metadata: currDataRequestObj})
                        executeApplyooComponentsFunction("onValidationError",{lstValidationErrors: lstValidationErrors, queryName: currDataRequestObj.ResponseName})
                        //prmActionsManager?.triggersManager.raiseEvent(prmActionsManager,eSystemEvents.OnDataValidationFail,currDataRequestObj)
                    }
                    else {
                        fireApplyooEvent({eventType: eSystemEvents.OnDataValidationSucceed, metadata: currDataRequestObj})

                        //prmActionsManager?.triggersManager.raiseEvent(prmActionsManager,eSystemEvents.OnDataValidationSucceed,currDataRequestObj)
                    }
                }
            }


            //comment: handle validations by components using validateElementBeforeSave
            let dicValidationResponse:any = executeApplyooComponentsFunctionWithReturnValue("validateElementBeforeSave", {
                actionParams: prmActionParameters,
                dataRequestObj: currDataRequestObj,
                queryInfo: lstQueryTablesInfo,
                pageData: pageDataObj,
            })

            if (!!dicValidationResponse
                && !isSkipValidation
                && Object.keys(dicValidationResponse).length > 0 ){
                isValid = false
                for (const currValidationResponseKey in dicValidationResponse) {
                    let arrCurrValidationResponseItems = dicValidationResponse[currValidationResponseKey]

                    if (Array.isArray(arrCurrValidationResponseItems)){
                        lstValidationErrors.push(...arrCurrValidationResponseItems)
                        isValid = false
                    }
                }
            }

            if (isValid){
                fireApplyooEvent({eventType: eSystemEvents.BeforeSave, metadata: currDataRequestObj})
                //prmActionsManager?.triggersManager.raiseEvent(prmActionsManager,eSystemEvents.BeforeSave,currDataRequestObj)

                for (let ind02 = 0; ind02 < arrSaveQueries.length; ind02++) {
                    currDataRequestObj = arrSaveQueries[ind02];

                    //comment: check if the same query name is calling save more than once (capture double click)
                    if (!!save.dicActiveSave[currDataRequestObj.ResponseName]) {
                        let currActiveSaveItemDT:any = save.dicActiveSave[currDataRequestObj.ResponseName]
                        const diffInMs = new Date().getTime() - currActiveSaveItemDT.getTime();

                        if (diffInMs < 1000) {
                            utils_log.writeToLog(`ignore double save for ResponseName: ${currDataRequestObj.ResponseName}`)
                            continue;
                        }
                    }

                    if (!pageDataObj?.getDataResponseObj?.DicQueryEntityHierarchy
                            || !currDataRequestObj?.ResponseName
                            || !pageDataObj.getDataResponseObj.DicQueryEntityHierarchy[currDataRequestObj.ResponseName]) {
                        continue;
                    }

                    save.dicActiveSave[currDataRequestObj.ResponseName] = new Date();

                    let dataObj = {...pageDataObj.data[currDataRequestObj.ResponseName]};
                    lstQueryTablesInfo = pageDataObj.getDataResponseObj.DicQueryEntityHierarchy[currDataRequestObj.ResponseName];

                    let lstSaveTags:any = []

                    if (!!lstQueryTablesInfo){
                        // let convertedObj:any = convertToHierarchyData(dataObj,lstQueryTablesInfo[0],currDataRequestObj.ResponseName);
                        //
                        // if (!!convertedObj?.convertedToHierarchyData
                        //     && !!convertedObj?.convertedToHierarchyData[currDataRequestObj.ResponseName]){
                        //     dataObj = convertedObj?.convertedToHierarchyData[currDataRequestObj.ResponseName]
                        // }
                        //let newDataObj = convertToHierarchyData(dataObj,lstQueryTablesInfo)
                        dataObj.tb_Files = save.getFiles(pageDataObj,currDataRequestObj.ResponseName); //dataObj,pageDataObj.lstFiles;

                        //let currLstQueryEntityHierarchy = currDataRequestObj.LstQueryEntityHierarchy;
                        let originalData = pageDataObj.originalData[currDataRequestObj.ResponseName];

                        if (!!prmActionParameters
                            && !!prmActionParameters?.IsIgnoreOriginalData){
                            originalData = {};
                        }

                        //let result = dataUtils.deepDiffBetweenObjects(originalData,dataObj)

                        let dicOutRelatedEntityRows:any = {};
                        dataObj = save.handleSingleRow_IfNeeded(pageDataObj,currDataRequestObj,dataObj);
                        originalData = save.handleSingleRow_IfNeeded(pageDataObj,currDataRequestObj,originalData);
                        let lstSaveMetaData = save.getChangesListForHierarchyData(originalData,dataObj,lstQueryTablesInfo,null,dicOutRelatedEntityRows); //(pageDataObj,currDataRequestObj, dataObj, originalData);

                        dataObj = this.prepareDataToSave(pageDataObj,currDataRequestObj,lstQueryTablesInfo, dataObj);

                        if (!!prmActionParameters?.lstIgnoreEntitiesDelete
                                && !!lstSaveMetaData){

                            let lstDeletedIgnoredItems = lstSaveMetaData.filter((prmItem:any) => {
                                return prmItem.SaveState == "Delete"
                                            && prmActionParameters.lstIgnoreEntitiesDelete.indexOf(prmItem.ObjName) > -1
                            });

                            if (lstDeletedIgnoredItems.length > 0){
                                for (const currDeletedIgnoredItem of lstDeletedIgnoredItems) {
                                    let currIndex = lstSaveMetaData.indexOf(currDeletedIgnoredItem)

                                    if (currIndex > -1){
                                        lstSaveMetaData.splice(currIndex,1)
                                    }
                                }
                            }

                            // if (!!lstSaveMetaData && lstSaveMetaData.filter((prmItem:any) => {return prmItem.ActionType == "Delete"}).length > 0){
                            // }
                            //SaveState: "Delete"
                        }
                        //TODO: check why rows are deleted from credit management checklists


                        //Todo : check if only 1 todo added
                        //dataObj = this.prepareDataToSave(pageDataObj,currDataRequestObj,lstQueryTablesInfo, dataObj);

                        let lstSaveFilesMetaData = save.getFileChanges(pageDataObj,dataObj.tb_Files,currDataRequestObj.ResponseName);

                        if (!currDataRequestObj.IsSingleRow
                            && !prmActionParameters?.IsIgnoreOriginalData){
                            let changedDataObj:any = {}

                            for (const currSaveMetaDataItem of lstSaveMetaData) {
                                if (currSaveMetaDataItem.SaveState != "Delete"
                                        && dataObj.hasOwnProperty(currSaveMetaDataItem.ObjName)){
                                    if (!changedDataObj.hasOwnProperty(currSaveMetaDataItem.ObjName)){
                                        changedDataObj[currSaveMetaDataItem.ObjName] = []
                                    }

                                    let currTablePrimaryKey = ""

                                    if (!!lstQueryTablesInfo && lstQueryTablesInfo.length > 0){
                                        let currQueryInfo = lstQueryTablesInfo[0]

                                        if (currQueryInfo.EntityName == currSaveMetaDataItem.ObjName){
                                            currTablePrimaryKey = currQueryInfo.KeyField
                                        }
                                        else {
                                            let currChildObj = currQueryInfo.QueryResponseObj.LstChildren?.find((prmItem:any) => {
                                                return prmItem.EntityName == currSaveMetaDataItem.ObjName
                                            })

                                            if (!!currChildObj){
                                                currTablePrimaryKey = currChildObj.KeyField
                                            }
                                        }
                                    }

                                    if (!!currTablePrimaryKey){
                                        let relevantRowObj = dataObj[currSaveMetaDataItem.ObjName]?.find((prmItem:any) => {
                                            return prmItem[currTablePrimaryKey] == currSaveMetaDataItem.ID
                                        })

                                        if (!!relevantRowObj){
                                            changedDataObj[currSaveMetaDataItem.ObjName].push(relevantRowObj)
                                        }
                                    }

                                }

                            }

                            dataObj = changedDataObj
                        }

                        let isValidSave = true

                        if (prmActionParameters?.validateMetaDataBeforeSave_CallbackFunction) {
                            isValidSave = prmActionParameters?.validateMetaDataBeforeSave_CallbackFunction({dataObj,originalData,lstSaveMetaData,lstSaveFilesMetaData})
                        }

                        if (isValidSave && (lstSaveMetaData.length > 0 || lstSaveFilesMetaData.length > 0)){
                            let dataToSaveObj = cloneDeep(dataObj)

                            let dicSaveTags = executeApplyooComponentsFunctionWithReturnValue("getSaveTags",{dataToSaveObj: dataToSaveObj, lstQueryTablesInfo: lstQueryTablesInfo, responseName: currDataRequestObj.ResponseName, lstSaveMetaData: lstSaveMetaData}) || []

                            if (!utils_ui.isObjEmpty(dicSaveTags)) {
                                lstSaveTags = save.parseSaveTags(dicSaveTags)
                            }

                            utils_ui.convertAllDatesToUTCStr(dataToSaveObj)

                            //lstSaveMetaData = lstSaveMetaData.concat(lstSaveFilesMetaData);

                            let prmParamsObj = {
                                "prmProjectID": currProjectID,
                                "prmPageCode": currPageCode,
                                "prmLstSaveQueryByResponseParams": [
                                    {
                                        "ProjectID": currProjectID,
                                        "ResponseName": currDataRequestObj.ResponseName,
                                        "DsData": dataToSaveObj,
                                        "LstSaveMetaDataItems": lstSaveMetaData,
                                        "LstSaveFilesMetaData": lstSaveFilesMetaData,
                                        "LstSaveTags": lstSaveTags,
                                        "LstAuditMetaData": [],
                                        "LstQueryEntityHierarchy": lstQueryTablesInfo,
                                    }
                                ]
                            }

                            callPostService("clsSvc_DataRequest_SaveQueryData",prmParamsObj).then((prmResponse:webResponseObject) => {
                                if (!!prmResponse?.reponseObj) {
                                    let currResponseObj = prmResponse?.reponseObj;

                                    currResponseObj._requestObj = prmParamsObj
                                    //SET_NEW_ENTITY_KEY
                                    // store.dispatch({type: 'SET_PAGE_STATE',
                                    //     lstQueryNames:arrSaveQueries,
                                    //     pageState: '',
                                    // });

                                    if (currResponseObj.isValid){
                                        store.dispatch({type: 'SET_NEW_ENTITY_KEY',
                                            primaryEntityID: currResponseObj.objID,
                                            responseName: queryName
                                        });

                                        if (lstSaveFilesMetaData.length > 0) {
                                            store.dispatch({type: 'CLEAR_ORIGINAL_FILES_STATE',
                                                responseName: queryName
                                            });

                                        }

                                        if (!prmActionParameters?.IsIgnoreFireEventAfterSave) {
                                            executeApplyooComponentsFunction("onSaveSucceed",{metadata: prmParamsObj, responseObj: currResponseObj, queryName: queryName, lstSaveFilesMetadata: lstSaveFilesMetaData})
                                            fireApplyooEvent({eventType: eSystemEvents.AfterSave_Succeed, metadata: prmParamsObj, responseObj: currResponseObj})

                                            sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "playSound", soundType: "success"})
                                        }

                                        // if (!prmActionParameters?.IgnoreExecuteQueryAfterSave){
                                        //     prmActionsManager?.executeActions([{ActionTypeCode:"executeQuery", ActionParameters:{queryName:queryName}}])
                                        // }

                                        //prmActionsManager?.triggersManager?.raiseEvent(prmActionsManager,eSystemEvents.AfterSave_Succeed,prmParamsObj);
                                    }
                                    else {
                                        if (!!currResponseObj.lstValidationNotifications) {
                                            let allErrorMessagesStr = currResponseObj.lstValidationNotifications.map((prmItem:any) => {
                                                return prmItem.Message
                                            }).join("\n\n")

                                            utils_log.writeToLog(allErrorMessagesStr)
                                        }

                                        if (!prmActionParameters?.IsIgnoreFireEventAfterSave) {
                                            executeApplyooComponentsFunction("onSaveFailed", {
                                                metadata: prmParamsObj,
                                                responseObj: currResponseObj
                                            })
                                            fireApplyooEvent({
                                                eventType: eSystemEvents.AfterSave_Failed,
                                                metadata: prmParamsObj,
                                                responseObj: currResponseObj
                                            })
                                            sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {
                                                command: "playSound",
                                                soundType: "error"
                                            })
                                        }
                                        //prmActionsManager?.triggersManager.raiseEvent(prmActionsManager,eSystemEvents.AfterSave_Failed,prmParamsObj)
                                        //alert("TODO - ERROR")
                                    }

                                    executeApplyooComponentsFunction("afterSaveQueryData",{paramsObj: prmParamsObj,
                                        responseObj: currResponseObj,
                                        isValid: currResponseObj.isValid,
                                        IgnoreExecuteQueryAfterSave: prmActionParameters?.IgnoreExecuteQueryAfterSave,
                                        queryName: queryName || currDataRequestObj.ResponseName,
                                        NumOfRows: currDataRequestObj?.NumOfRows
                                    })

                                    if (!!prmActionParameters
                                        && !!prmActionParameters?.callbackFunction){
                                        prmActionParameters.callbackFunction(currResponseObj);
                                    }
                                }
                                else {
                                    utils_ui.showToaster(utils_ui.getLanguageTitle("Title_SaveError"),'error')
                                }
                            })
                        }
                        else {
                            if (!prmActionParameters?.IsDisableSaveToaster) {
                                utils_ui.showToaster(utils_ui.getLanguageTitle("Title_Alert_DataContainsNoChanges"),'info')
                            }

                            if (!!prmActionParameters
                                && !!prmActionParameters?.callbackFunction){
                                prmActionParameters.callbackFunction({"responseType": "DataContainsNoChanges"});
                            }
                        }

                    }

                }


            }
            else {
                store.dispatch({type: 'SET_VALIDATION_ERRORS',
                    queryName: queryName,
                    lstValidationErrors:lstValidationErrors
                });
            }


        }

    }

    static parseSaveTags = (prmDicSaveTags:any) => {
        let lstOut:any = []

        for (const currKey in prmDicSaveTags) {
            for (const currTag of prmDicSaveTags[currKey]) {
                if (!lstOut.includes(currTag)) {
                    lstOut.push(currTag)
                }
            }
        }

        return lstOut
    }

    static getFiles = (prmPageData:any,prmResponseName:any) => {
        let lstOut:any = [];
        //let newFileIndex=0;

        if (!!prmResponseName && prmPageData.dicResponseExtData[prmResponseName]){
            lstOut = cloneDeep(prmPageData.dicResponseExtData[prmResponseName].lstFiles || [])
        }

        for (let ind01 = 0; ind01 < lstOut?.length; ind01++) {
            let currFile = lstOut[ind01];

            if (currFile.ID <= 0){
                currFile.ID = utils_ui.getNextNewID() //--newFileIndex;
            }
        }

        return lstOut;
    }

    static getFileChanges= (prmPageData:any, prmActualFiles:any,prmResponseName:any) => {
        let lstOut = [];
        let lstOrigFiles = []
        let dicOrigFiles:any = {}
        let dicActualFiles:any = dataUtils.convertArrayToDicObject(prmActualFiles,"ID")

        if (!!prmResponseName
            && prmPageData.dicResponseExtData[prmResponseName]
            && !!prmPageData.dicResponseExtData[prmResponseName].lstOriginalFiles){
            lstOrigFiles = cloneDeep(prmPageData.dicResponseExtData[prmResponseName].lstOriginalFiles)

            dicOrigFiles = dataUtils.convertArrayToDicObject(lstOrigFiles,"ID")

            //comment: handle new files
            let newIndex = 0;
            for (const currFile of prmActualFiles) {
                if (currFile.ID < 0 || !dicOrigFiles[currFile.ID]){
                    lstOut.push({
                        ObjName: 'tb_Files',
                        Index: newIndex++,
                        ID: currFile.ID,
                        Comments: `${currFile.FileDisplayName} (${currFile.FileSizeStr})`,
                        SaveState: 'New'})
                }
            }

            //comment: handle deleted files
            //let newIndex = 0;
            for (const currOrigFile of lstOrigFiles) {
                if (currOrigFile.ID > 0 && !dicActualFiles[currOrigFile.ID]){
                    lstOut.push({
                        ObjName: 'tb_Files',
                        Index: newIndex++,
                        ID: currOrigFile.ID,
                        Comments: `${currOrigFile.FileDisplayName} (${currOrigFile.FileSizeStr})`,
                        SaveState: 'Delete'})
                }
                else if (currOrigFile.ID > 0
                    && (dicActualFiles[currOrigFile.ID].Comments != currOrigFile.Comments
                            || dicActualFiles[currOrigFile.ID].Tags != currOrigFile.Tags)) {
                    lstOut.push({
                        ObjName: 'tb_Files',
                        Index: newIndex++,
                        ID: currOrigFile.ID,
                        Comments: `${currOrigFile.FileDisplayName} (${currOrigFile.FileSizeStr})`,
                        SaveState: 'Modify'})
                }
            }
        }

        return lstOut;
    }

    static handleSingleRow_IfNeeded = (prmPageData:any, prmDataRequestObj:any,prmDataObj:any) =>{
        let outObj = prmDataObj;

        if (prmDataRequestObj?.IsSingleRow){
            let arrData = [];
            arrData.push(prmDataObj[prmDataRequestObj.PrimaryEntityName]);
            outObj[prmDataRequestObj.PrimaryEntityName] = arrData;
        }

        return outObj;
    }

    prepareDataToSave= (prmPageData:any, prmDataRequestObj:any, prmlstQueryTablesInfo:any, prmDataObj:any) => {
        let outObj = prmDataObj;

        for (let ind01 = 0; ind01 < prmlstQueryTablesInfo.length; ind01++) {
            let currQueryTableInfo = prmlstQueryTablesInfo[ind01];
            //let currTableData = outObj[currQueryTableInfo.EntityName];
            // let dicSubTables = dataUtils.convertArrayToDicObject(currQueryTableInfo.QueryResponseObj.LstChildren,"EntityName");

            //comment: prepare flat data tables
            currQueryTableInfo.QueryResponseObj.LstChildren.map((prmChildTableItem:any) => {
                if (prmChildTableItem.QueryResponseObj.IsAllowSave){
                    outObj[prmChildTableItem.EntityName] = [];
                }
            })

            //comment: remove unregistered fields
            let primaryDataObj = outObj[currQueryTableInfo.EntityName];
            for (let ind02 = 0; ind02 < primaryDataObj.length; ind02++) {
                let currRow = primaryDataObj[ind02];

                //comment: handle flat data tables rows
                currQueryTableInfo.QueryResponseObj.LstChildren.map((prmChildTableItem:any) => {
                    if (!!prmChildTableItem.QueryResponseObj.IsAllowSave && !!currRow && !!currRow[prmChildTableItem.EntityName]){

                        let lstChildRows = currRow[prmChildTableItem.EntityName];

                        for (let ind03 = 0; ind03 < lstChildRows.length; ind03++) {
                            let childRowItem = lstChildRows[ind03];

                            for (const subDataRowItemKey in childRowItem) {
                                if (prmChildTableItem.LstFields?.indexOf(subDataRowItemKey) == -1){
                                    delete childRowItem[subDataRowItemKey];
                                }
                                else if (ind03 == 0 && lstChildRows.length > 1 && prmChildTableItem?.LstDecimalTypeFields?.indexOf(subDataRowItemKey) > -1) {
                                    if (!!childRowItem[subDataRowItemKey]
                                        && parseInt(childRowItem[subDataRowItemKey]) == parseFloat(childRowItem[subDataRowItemKey])) {
                                        childRowItem[subDataRowItemKey] = parseFloat(childRowItem[subDataRowItemKey].toString()) + this.valueToAddFirstDecimalTypeFieldRow
                                    }
                                }
                            }

                            childRowItem[prmChildTableItem.SubEntityKeyField] = currRow[prmChildTableItem.ParentEntityKeyField];
                            outObj[prmChildTableItem.EntityName].push(childRowItem);
                        }

                    }
                })

                for (const currKey in currRow) {
                    if (currQueryTableInfo.LstFields?.indexOf(currKey) == -1){
                        delete currRow[currKey];
                    }
                    else if (ind02 == 0
                                && primaryDataObj.length > 1 //comment: check if current array contains more than 1 row
                                && currQueryTableInfo.LstDecimalTypeFields?.indexOf(currKey) > -1) {
                        if (!!currRow[currKey]
                            && parseInt(currRow[currKey]) == parseFloat(currRow[currKey])) {
                            currRow[currKey] = parseFloat(currRow[currKey].toString()) + this.valueToAddFirstDecimalTypeFieldRow
                        }
                    }
                }

            }
        }

        return outObj;
    }

   static getChangesListForHierarchyData = (prmOriginalDataObj:any, prmNewDataObj:any, prmArrEntitesMetaData:any,dicIgnoredEntityFields:any, dicOutRelatedEntityRows:any) => {
        let arrOut:any = [];
        // let that = this;

       if (!!prmArrEntitesMetaData) {
           for (let ind01 = 0; ind01 < prmArrEntitesMetaData.length; ind01++) {
               let currEntitesMetaDataObj = prmArrEntitesMetaData[ind01];
               let currArrOrigin = prmOriginalDataObj[currEntitesMetaDataObj.EntityName]
               let currArrNew = prmNewDataObj[currEntitesMetaDataObj.EntityName]

               let arrCurrChanges = this.getChangesListForSpecificEntityMetaDataObj(currArrOrigin, currArrNew, currEntitesMetaDataObj,dicIgnoredEntityFields, dicOutRelatedEntityRows);

               arrOut = arrOut.concat(arrCurrChanges);

           }
       }

        return arrOut;
}


// getSaveMetadata = (prmPageData:any, prmDataRequestObj:any, prmActualDataObj:any, prmOriginalDataObj:any) =>{
//         let lstChanges = [];
//
//         for (const dataTableName in prmActualDataObj) {
//             let actualDataTableObj = prmActualDataObj[dataTableName];
//             let originalDataTableObj = null;
//
//             if (!!prmOriginalDataObj[dataTableName]){
//                 originalDataTableObj = prmOriginalDataObj[dataTableName];
//             }
//
//         }
//
//         let changeObj = {
//             "ObjName": "tb_DealOpportunities",
//             "Index": 0,
//             "ID": "-1",
//             "SaveState": "New"
//         }
//
//         lstChanges.push(changeObj);
//     }

    static getChangesListForSpecificEntityMetaDataObj = (prmArrOrigin:any, prmArrNew:any, currEntitesMetaDataObj:any,dicIgnoredEntityFields:any, prmOutDicRelatedDataRows:any) => {
        let arrOut:any = [];

        let dicOriginObjs:any = {};

        if (currEntitesMetaDataObj.QueryResponseObj.IsAllowSave) {
            if (!!prmArrOrigin) {
                for (let ind02 = 0; ind02 < prmArrOrigin.length; ind02++) {

                    let currOriginObj = prmArrOrigin[ind02];

                    if (!!currOriginObj && !!currEntitesMetaDataObj?.KeyField) {
                        let currKey = currOriginObj[currEntitesMetaDataObj?.KeyField];

                        if (!!currKey) {
                            dicOriginObjs[currKey] = currOriginObj;
                        }
                    }
                }
            }


            let dicNewObjs:{[id: string] : any; } = {};

            if (!!prmArrNew) {

                for (let ind02 = 0; ind02 < prmArrNew.length; ind02++) {
                    let currNewObj = prmArrNew[ind02];

                    if (!!currNewObj){
                        let currKey = currNewObj[currEntitesMetaDataObj.KeyField];
                        if (currKey === undefined || currKey === null) {
                            currKey = 0;
                        }
                        if (currKey == 0) {
                            currKey = this.newKeyNumber;
                            currNewObj[currEntitesMetaDataObj.KeyField] = this.newKeyNumber--;
                            // this.newKeyNumber--;
                        }


                        dicNewObjs[currKey] = currNewObj;
                    }

                }
            }

            // let dicHandledRows = {};

            //find deleted items
            for (let currKey in dicOriginObjs) {

                if (!dicNewObjs.hasOwnProperty(currKey)) {

                    //TODO: ask yuval - we dont have the data on the newArr

                    //  let currIndex = prmArrNew[]

                    let newChangeListItem = {
                        ObjName: currEntitesMetaDataObj.EntityName,
                        ID: currKey,
                        SaveState: "Delete"
                    };

                    arrOut.push(newChangeListItem);

                    if (!!currEntitesMetaDataObj.QueryResponseObj.LstChildren) {

                        let originObj = dicOriginObjs[currKey];

                        for (let ind01 = 0; ind01 < currEntitesMetaDataObj.QueryResponseObj.LstChildren.length; ind01++) {

                            let currNavObjMetaData = currEntitesMetaDataObj.QueryResponseObj.LstChildren[ind01];

                            let arrOriginNav = originObj[currNavObjMetaData.EntityName];
                            let arrNewNav:any = [];
                            //let arrRelatedDataRows = [];
                            let arrChanges = this.getChangesListForSpecificEntityMetaDataObj(arrOriginNav, arrNewNav, currNavObjMetaData,null, prmOutDicRelatedDataRows);

                            if (!!arrChanges){
                                arrOut = arrOut.concat(arrChanges);
                            }
                            //outArrRelatedDataRows = outArrRelatedDataRows.concat(arrRelatedDataRows);
                        }
                    }
                }
            }


            //find add or modified objects
            for (let currKey in dicNewObjs) {

                if (!dicOriginObjs.hasOwnProperty(currKey)) {

                    let currNewObj = dicNewObjs[currKey];
                    let currIndex = prmArrNew.indexOf(currNewObj);

                    //prmOutDicRelatedDataRows.push(currNewObj);
                    if (!prmOutDicRelatedDataRows[currEntitesMetaDataObj.EntityName]) {
                        prmOutDicRelatedDataRows[currEntitesMetaDataObj.EntityName] = [];
                    }

                    prmOutDicRelatedDataRows[currEntitesMetaDataObj.EntityName].push(currNewObj);

                    let newChangeListItem = {
                        ObjName: currEntitesMetaDataObj.EntityName,
                        Index: currIndex,
                        ID: currKey,
                        SaveState: "New"
                    };

                    arrOut.push(newChangeListItem);

                    if (!!currEntitesMetaDataObj.QueryResponseObj.LstChildren) {

                        let newObj = dicNewObjs[currKey];

                        for (let ind01 = 0; ind01 < currEntitesMetaDataObj.QueryResponseObj.LstChildren.length; ind01++) {

                            let currNavObjMetaData = currEntitesMetaDataObj.QueryResponseObj.LstChildren[ind01];

                            let arrOriginNav:any = [];
                            let arrNewNav = newObj[currNavObjMetaData.EntityName];

                            let arrChanges = this.getChangesListForSpecificEntityMetaDataObj(arrOriginNav, arrNewNav, currNavObjMetaData,null, prmOutDicRelatedDataRows);

                            if (!!arrChanges){
                                arrOut = arrOut.concat(arrChanges);
                            }
                        }
                    }
                }
                else {

                    // check if object modified
                    let originObj = dicOriginObjs[currKey];
                    let newObj = dicNewObjs[currKey];
                    //    

                    let currIndex = prmArrNew.indexOf(newObj);


                    if (utils_ui.isObjModified(originObj, newObj, currEntitesMetaDataObj.LstFields)) {
                        if (!prmOutDicRelatedDataRows[currEntitesMetaDataObj.EntityName]) {
                            prmOutDicRelatedDataRows[currEntitesMetaDataObj.EntityName] = [];
                        }

                        prmOutDicRelatedDataRows[currEntitesMetaDataObj.EntityName].push(newObj);

                        let newChangeListItem = {
                            ObjName: currEntitesMetaDataObj.EntityName,
                            Index: currIndex,
                            ID: currKey,
                            SaveState: "Modify"
                        };

                        arrOut.push(newChangeListItem);
                    }

                    if (!!currEntitesMetaDataObj.QueryResponseObj.LstChildren) {

                        for (let ind01 = 0; ind01 < currEntitesMetaDataObj.QueryResponseObj.LstChildren.length; ind01++) {

                            let currNavObjMetaData = currEntitesMetaDataObj.QueryResponseObj.LstChildren[ind01];

                            let arrOriginNav = originObj[currNavObjMetaData.EntityName];
                            let arrNewNav = newObj[currNavObjMetaData.EntityName];

                            let arrChanges = this.getChangesListForSpecificEntityMetaDataObj(arrOriginNav, arrNewNav, currNavObjMetaData,null, prmOutDicRelatedDataRows);

                            if (!!arrChanges){
                                arrOut = arrOut.concat(arrChanges);
                            }

                        }
                    }
                }


            }
        }

        utils_log.writeObjectToLog("getChangesListForSpecificEntityMetaDataObj",arrOut)

        return arrOut;
    }



}
